import { SeparatorBlue600 } from "../../../../../../components/styled-components";
import globals from "../../../../../../config/appconfig";
import "./CategoryDetailAllegattiListComponent.scss";
import PropTypes from "prop-types";

/**
 * @function CategoryDetailAllegattiListComponent test components
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
 */
const CategoryDetailAllegattiListComponent = ( { items } ) => {
    const dowloadPdf = (file) => {
        window.open( `${ globals[ "app-url-bucket" ] }${ file }` );
    }
    return (
        items?.length ? ( <><div className="CategoryDetailAllegattiListComponent">
            <div className="CategoryDetailAllegattiListComponent__title mb-3" role="contentinfo" tabIndex="0" aria-label={"Allegati"}> Allegati:</div>
            <ul className="CategoryDetailAllegattiListComponent__List">
                { items?.map( item => {
                    return (
                        <li key={ item } className="CategoryDetailAllegattiListComponent__ListItem" onClick={() => dowloadPdf(item?.file)}>
                            <div className="d-flex">
                                <span className="material-icons-outlined" aria-hidden="true" role="contentinfo" tabIndex="0" aria-label={"file_download"}>file_download</span>
                                <div>
                                    <a className="custom-link" role="contentinfo" tabIndex="0" aria-label={item?.descrizione}>{item?.descrizione}</a>
                                    <div className="CategoryDetailAllegattiListComponent__ListItem--dimensione" role="contentinfo" tabIndex="0" aria-label={item?.dimensione}>{`[${ item?.dimensione }]`}</div>
                                </div>

                            </div>
                        </li>
                    );
                } ) }
            </ul>

        </div>  <SeparatorBlue600 className="mb-3"></SeparatorBlue600></> ) : null
    );
};

CategoryDetailAllegattiListComponent.propTypes = {
    info: PropTypes.string.isRequired,
};

CategoryDetailAllegattiListComponent.defaultProps = {
    info: "",
};

export default CategoryDetailAllegattiListComponent;